/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M8.25 12.75c-1.6569 0-3 1.3431-3 3s1.3431 3 3 3 3-1.3431 3-3a.75.75 0 0 1 1.5 0c0 2.4853-2.0147 4.5-4.5 4.5s-4.5-2.0147-4.5-4.5 2.0147-4.5 4.5-4.5a.75.75 0 0 1 0 1.5Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.8319 7.1074A4.4798 4.4798 0 0 1 15 4.5C15 2.0147 17.0147 0 19.5 0S24 2.0147 24 4.5 21.9853 9 19.5 9a4.4794 4.4794 0 0 1-2.6074-.832L14.59 10.4708c1.1925 1.4306 1.91 3.2712 1.91 5.2793 0 4.5563-3.6937 8.25-8.25 8.25C3.6936 24 0 20.3063 0 15.75S3.6936 7.5 8.25 7.5c2.0081 0 3.8487.7175 5.2793 1.91l2.3026-2.3026ZM22.5 4.5c0 1.6569-1.3431 3-3 3a2.9863 2.9863 0 0 1-1.524-.4154l2.0543-2.0543a.75.75 0 0 0-1.0606-1.0606L16.9154 6.024A2.9853 2.9853 0 0 1 16.5 4.5c0-1.6568 1.3431-3 3-3s3 1.3432 3 3Zm-10.0367 5.9761C11.3085 9.5523 9.8438 9 8.25 9 4.522 9 1.5 12.0221 1.5 15.75s3.022 6.75 6.75 6.75c3.7279 0 6.75-3.0221 6.75-6.75a6.7218 6.7218 0 0 0-1.4761-4.2133l-4.7436 4.7436a.75.75 0 0 1-1.0606-1.0606l4.7436-4.7436Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'APIProxy'
);
